// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"9a5a4f10","135":"8d8ea1a6","185":"ed4e597f","246":"30bed0c4","543":"a0fb39af","787":"ce766eec","839":"5e6dd1e2","919":"4b171d5f"}[chunkId] + ".chunk.js";
};